/* @ngInject */

export default () => ({
  restrict: 'E',
  scope: {
    data: '='
  },
  link: (scope, element, attrs) => {
    d3.select(element[0])
      .append('div')
      .attr('class', 'chart')
      .selectAll('div')
      .data(scope.data)
      .enter()
      .append('div')
      .attr('class', 'line')
      .append('div')
      .append('strong')
      .text((item) => `${item.value}`)
      .append('span')
      .text((item) => ` - ${item.label}`)
      .append('div')
      .attr('class', 'bar')
      .style('width', (item) => `${item.dimension}%`);
  }
});
